import HolderHeadline from './HolderHeadline'

export default HolderHeadline
